import './Helpers.scss';

import { SystemPointsEnum } from 'domain/event/SystemPoints.enum';
import { TypeEventCodeEnum } from 'domain/event/TypeEventCodeEnum';
import { HelperPopper } from 'primary/helpers/HelperPopper';
import { useTranslate } from 'primary/hooks/useTranslate';
import React from 'react';

export const SystemPointsHelper = ({ type }: { type: TypeEventCodeEnum }) => {
  const t = useTranslate();
  return (
    <HelperPopper color={'white'} placement={'top'}>
      <div className={'helpers'}>
        {type !== TypeEventCodeEnum.LIG_BR && (
          <div className={'-blocTypeEvent'}>
            <h4 className={'-accent'}>
              {t(`enum.systemPoints.${SystemPointsEnum.DEFAULT}`)}
            </h4>
            <p>{t('helpers.events.pointsSystem.DEFAULT')}</p>
          </div>
        )}
        {(type === TypeEventCodeEnum.LIGUE || type == TypeEventCodeEnum.LIG_BR) && (
          <div className={'-blocTypeEvent'}>
            <h4 className={'-accent'}>
              {t(`enum.systemPoints.${SystemPointsEnum.PERSO}`)}
            </h4>
            <p>{t('helpers.events.pointsSystem.PERSO')}</p>
          </div>
        )}
      </div>
    </HelperPopper>
  );
};
